import React, { useState, useRef, useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { MiniFooter } from '@app/src/common/MiniFooter';
import { ButtonsAction } from '@app/src/common/ButtonsAction';
import {
  ButtonPrevWrapper,
  ButtonNextWrapper,
  ButtonActionsWrapper,
  Wrapper,
} from './styled';
import { isClientEnv } from '@app/src/utils/validations';
import { COLORS } from '@app/src/ui';

const isClient = isClientEnv();
const BREAKPOINT = 768;

interface Props {
  priceTotal?: string;
  handleClickSubmit?: Function;
  disabledButtonNext?: boolean;
  textButtonNext?: string;
  handleClickBack?: Function;
  textButtonBack?: string;
}

export const FormActions: React.FC<Props> = ({
  handleClickSubmit,
  disabledButtonNext,
  textButtonNext,
  handleClickBack,
  textButtonBack
}) => {
  const dispatch = useDispatch();
  const [isFixedActionsButtons, setIsFixedActionsButtons] = useState(false);
  let active = false;
  const [isDisabledScroll, setIsDisabledScroll] = useState(false);
  const refWrapper = useRef(null);
  const refFooter = useRef(null);

  useEffect(() => {
    if (isClient) {
      if (window.innerWidth < BREAKPOINT) {
        window.addEventListener('scroll', handleScroll);
      }
      window.addEventListener('resize', handleResizeWindow);
      return () => {
        window.removeEventListener('resize', handleResizeWindow);
        if (window.innerWidth < BREAKPOINT) {
          window.removeEventListener('scroll', handleScroll);
        }
      }
    }
  }, []);

  const handleResizeWindow = useCallback(() => {
    if (window.innerWidth >= BREAKPOINT) {
      setIsFixedActionsButtons(false);
      window.removeEventListener('scroll', handleScroll)
    } else {
      window.addEventListener('scroll', handleScroll)
      if (active) {
        active = false;
      }
    }
  }, [dispatch]);

  const disabledScroll = () => {
    setIsDisabledScroll(false)
    setTimeout(() => {
      setIsDisabledScroll(true)
    }, 500)
  }

  const handleScroll = useCallback(() => {
    const bodyHeight = document.body.offsetHeight;
    const fixedElementHeight = refWrapper.current.offsetHeight;
    const footerHeight = refFooter.current.offsetHeight;

    if (!isDisabledScroll) {
      if (bodyHeight - (window.pageYOffset + window.innerHeight) > fixedElementHeight && active === false) {
        active = true;
        setIsFixedActionsButtons(true);
        disabledScroll();
      }
      if (bodyHeight - (window.pageYOffset + window.innerHeight) <= footerHeight && active === true) {
        active = false;
        setIsFixedActionsButtons(false)
        disabledScroll()
      }
    }
  }, [dispatch])

  const handleClickGoBack = (e) => {
    e.preventDefault();
    handleClickBack && handleClickBack();
  }

  return (
    <Wrapper ref={refWrapper}>
      <ButtonActionsWrapper fixed={isFixedActionsButtons} >
        <ButtonsAction
          ButtonPrev={
            <ButtonPrevWrapper
              handleClick={handleClickGoBack}
              background='#fff'
              color={COLORS.BLACK_BOLD}
              width={140}
              text={textButtonBack}
              icon={{ name: 'icon-back', color: COLORS.BLACK_BOLD, width: '16' }}
              left
            />
          }
          ButtonNext={
            <ButtonNextWrapper
              id="paymentAction"
              handleClick={handleClickSubmit}
              background={COLORS.BLACK_BOLD}
              color="#fff"
              disabled={disabledButtonNext}
              text={textButtonNext}
              width={152}
              type="submit"
            />
          }
        />
      </ButtonActionsWrapper>
      <MiniFooter refFooter={refFooter} />
    </Wrapper>
  )
};